import { useReducer } from 'react'

export type UseSetStatePayload<State> = [
  state: State,
  setState: (state: Partial<State>) => void,
]

function useSetState<State>(initState: State): UseSetStatePayload<State> {
  const reducer = (state: State, newState: Partial<State>) => ({ ...state, ...newState })
  const [state, setState] = useReducer(reducer, initState)

  return [state, setState]
}

export default useSetState
